import PlayerStatistics from 'components/sports/tte/views/PlayerStatistics'
import PlayerStatisticsTeam from './PlayerStatisticsTeam';

function TtePlayerStats({ data, results, isTeam = false, isTeamAndMain = false }) {

  const stats = [
    { code: 'DEF_OVC_MAX' },                                     //Greatest deficit overcome          
    { code: 'PTS_CONSEC' },                                      //Most consecutive points won
    { code: 'PTS_SERVICE_LOST' },                                //Points lost on own serve
    { code: 'PTS_SERVICE_WON' },                                 //Points won on own serve  
    { code: 'LEAD_MAX' },                                        //Biggest lead 
    { code: 'PTS_WON' },                                         //Points won
    //{ code: 'PTS_GAME' }                                       //Game points 
  ]
  return (<>
    {isTeamAndMain
      ? <PlayerStatisticsTeam data={data?.results} results={results} stats={stats} />
      : <PlayerStatistics data={data?.results} stats={stats} isTeam={isTeam} />
    }

  </>);
}

export default TtePlayerStats;